import React from "react";

import PropTypes from "prop-types";
import { Modal, BlockStack } from "@shopify/polaris";
import { useMutation } from "@apollo/client";

// import from lib.
import { baseHelper, errorHelper } from "lib/helpers";

// import GQL.
import { SYNC_ORDER_LAKE } from "app/orderLake/apollo/mutations";

// import constant.
import constant from "lib/constant/constant";

function SyncOrderLake(props) {
  const { cms, isSyncOpen, setIsSyncModal, setBanner, refetch } = props;
  const [SyncOrders, { loading }] = useMutation(SYNC_ORDER_LAKE);
  const handleCloseModal = () => {
    setIsSyncModal(false);
  };
  const handleSyncOrderLake = async () => {
    await SyncOrders()
      .then((res) => {
        setIsSyncModal(false);
        const responseData = baseHelper.getResponseData(res.data, constant.gql.SYNC_ORDER_LAKE);
        const responseDataError = baseHelper.getResponseError(res.data, constant.gql.SYNC_ORDER_LAKE);

        if (responseData) {
          refetch();
          setBanner({
            isOpen: true,
            status: "success",
            title: cms("message.success.updateSuccess"),
          });
        }
        if (responseDataError) {
          setBanner({
            isOpen: true,
            status: "critical",
            title: responseDataError,
          });
        }
      })
      .catch((exception) => {
        setIsSyncModal(false);
        setBanner({
          isOpen: true,
          status: "critical",
          title: errorHelper.parse(exception),
        });
      });
  };
  return (
    <>
      <Modal
        open={isSyncOpen}
        onClose={handleCloseModal}
        title={cms("section.syncOrder.label.modalLabel")}
        primaryAction={{
          content: cms("section.syncOrder.button.syncOrder"),
          onAction: handleSyncOrderLake,
          destructive: true,
          disabled: loading,
          loading,
        }}
        secondaryActions={[
          {
            content: cms("section.syncOrder.button.cancel"),
            onAction: handleCloseModal,
            disabled: loading,
          },
        ]}
      >
        <Modal.Section>
          <BlockStack gap="4">
            <p>{cms("message.success.modalMessage")}</p>
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>
  );
}

SyncOrderLake.defaultProps = {
  cms: () => {},
  isSyncOpen: false,
  setIsSyncModal: () => {},
  setBanner: () => {},
  refetch: () => {},
};

SyncOrderLake.propTypes = {
  cms: PropTypes.func,
  isSyncOpen: PropTypes.bool,
  setIsSyncModal: PropTypes.func,
  setBanner: PropTypes.func,
  refetch: PropTypes.func,
};

export default SyncOrderLake;
